module.exports = __webpack_public_path__ + "product2.e7c36c3b.png";